import { Routes } from '@angular/router';

function buildRoutes(isCohort: boolean): Routes {
  const defaultTab = isCohort ? 'enrolments' : 'sessions';
  const routeData = {
    basePath: isCohort ? 'cohorts' : 'course-intakes',
    isCohort,
  };

  return [
    {
      path: ':id',
      data: routeData,
      loadComponent: () =>
        import('./components/view/course-intake-view.component').then((m) => m.CourseIntakeViewComponent),
      children: [
        {
          path: 'enrolments',
          loadComponent: () =>
            import('./components/view/enrolments/course-intake-enrolments.component').then(
              (m) => m.CourseIntakeEnrolmentsComponent
            ),
        },
        {
          path: 'recordings',
          loadComponent: () =>
            import('./components/view/recordings/course-intake-recordings.component').then(
              (m) => m.CourseIntakeRecordingsComponent
            ),
        },
        {
          path: 'sessions',
          loadComponent: () =>
            import('./components/view/sessions/course-intake-sessions.component').then(
              (m) => m.CourseIntakeSessionsComponent
            ),
        },
        { path: '**', redirectTo: defaultTab },
      ],
    },
    {
      path: '',
      data: routeData,
      loadComponent: () =>
        import('./components/list/course-intake-list.component').then((m) => m.CourseIntakeListComponent),
    },
  ];
}

export const COHORT_ROUTES = buildRoutes(true);
export const COURSE_INTAKE_ROUTES = buildRoutes(false);
